// extracted by mini-css-extract-plugin
export default {"cookies":"Reminder_cookies__oXGYw","button":"Reminder_button__7Bae2"};